import { authenticatedFetch } from './api'; // CORRECTED IMPORT

/**
 * Fetches all compound alert rules.
 * @returns {Promise<Array>} A list of compound alert rules.
 */
export const fetchCompoundAlertRules = async () => {
    // CORRECTED FUNCTION CALL
    const response = await authenticatedFetch('/compound-alert-rules');
    return response;
};

/**
 * Fetches a single compound alert rule by its ID, including its steps.
 * @param {number} id - The ID of the compound alert rule.
 * @returns {Promise<Object>} The compound alert rule object with its steps.
 */
export const fetchCompoundAlertRuleById = async (id) => {
    // CORRECTED FUNCTION CALL
    const response = await authenticatedFetch(`/compound-alert-rules/${id}`);
    return response;
};

/**
 * Creates a new compound alert rule.
 * @param {object} ruleData - The data for the new rule, including the 'steps' array.
 * @returns {Promise<Object>} The newly created compound alert rule.
 */
export const createCompoundAlertRule = async (ruleData) => {
    // CORRECTED FUNCTION CALL
    const response = await authenticatedFetch('/compound-alert-rules', {
        method: 'POST',
        body: JSON.stringify(ruleData),
    });
    return response;
};

/**
 * Updates an existing compound alert rule.
 * @param {number} id - The ID of the rule to update.
 * @param {object} ruleData - The updated data for the rule, including the 'steps' array.
 * @returns {Promise<Object>} The updated compound alert rule.
 */
export const updateCompoundAlertRule = async (id, ruleData) => {
    // CORRECTED FUNCTION CALL
    const response = await authenticatedFetch(`/compound-alert-rules/${id}`, {
        method: 'PUT',
        body: JSON.stringify(ruleData),
    });
    return response;
};

/**
 * Deletes a compound alert rule by its ID.
 * @param {number} id - The ID of the rule to delete.
 * @returns {Promise<void>}
 */
export const deleteCompoundAlertRule = async (id) => {
    // CORRECTED FUNCTION CALL
    await authenticatedFetch(`/compound-alert-rules/${id}`, {
        method: 'DELETE',
    });
};